class o extends Error {
  constructor(r, t) {
    super(r), this.message = r, this.report = t, this.name = "DatasetValidationError", this.report = t;
  }
  get hasReport() {
    return !!this.report;
  }
}
export {
  o as DatasetValidationError
};
//# sourceMappingURL=DatasetValidationError.js.map
